module.exports = __webpack_public_path__ + "static/media/infoIcon.5d6bc5ac.svg";